// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1jdlr","ranges":"BmiRanges_ranges__2irx-"};